import React from 'react'

const MyCredits = () => {
    return (
        <div style={{ textAlign: "left", marginLeft: "40px" }} >
            <div style={{ fontSize: "28px", paddingBottom: "18px" }}>Your Credits</div>
            <div style={{ fontSize: "24px", boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px", padding: "5px 20px", borderRadius: "5px" }}>
                Available Fraazo Credit : ₹ 0
            </div>
            <div style={{ fontSize: "44px", paddingTop: "10px" }}>No data found</div>
        </div>
    )
}

export default MyCredits